import { useSyncExternalStore } from 'react';
import { Toaster } from 'sonner';

const MOBILE_QUERY = '(max-width: 640px)';

/** Follows the viewport, so rotating the phone or resizing the window moves the toasts too. */
function useIsMobile(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(MOBILE_QUERY);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => window.matchMedia(MOBILE_QUERY).matches,
    () => false,
  );
}

/**
 * Single toast host for the whole app. Colors come from the design tokens, which already
 * switch with data-theme, so light/dark needs no `theme` prop. Top-right on desktop and
 * bottom on mobile so it never covers the shell header.
 */
export function AppToaster() {
  const isMobile = useIsMobile();
  return (
    <Toaster
      position={isMobile ? 'bottom-center' : 'top-right'}
      // Below the shell header (56px) so it never covers the theme / search / user buttons.
      offset={{ top: 68, right: 16 }}
      mobileOffset={{ bottom: 16, left: 16, right: 16 }}
      closeButton
      richColors={false}
      toastOptions={{
        duration: 6000,
        style: {
          background: 'var(--surface)',
          color: 'var(--text-primary)',
          border: '1px solid var(--border-strong)',
          borderRadius: 'var(--radius-md)',
          boxShadow: 'var(--shadow-md)',
        },
        classNames: {
          description: '!text-[var(--text-muted)]',
          error: '!border-[var(--danger)]',
          success: '!border-[var(--success)]',
        },
      }}
      style={{ fontFamily: 'inherit' }}
      containerAriaLabel="Notificaciones"
    />
  );
}
